// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"264752cb","484":"0cf08bcf","551":"d591b3b2","683":"a7cb40c5"}[chunkId] + ".chunk.js";
};